import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M12.3703883,8.82416548 C12.0371498,8.31082412 11.5454785,7.96939915 10.8958561,7.80037211 L10.8958561,7.76762614 C11.2401705,7.60389625 11.5295871,7.42090402 11.7641061,7.21864945 C11.9991067,7.02747072 12.1792095,6.82521615 12.3048963,6.6123673 C12.5504911,6.16451789 12.6679914,5.69499836 12.6569156,5.20332713 C12.6569156,4.24213637 12.3593124,3.46923498 11.7641061,2.88462296 C11.1741969,2.30578965 10.2919818,2.01107585 9.11794216,2 L4.0375,2 L4.0375,13.944577 L9.51956195,13.944577 C10.4590826,13.944577 11.2425783,13.6306009 11.8710121,13.002167 C12.5047431,12.401182 12.8269057,11.5849404 12.8375,10.5529605 C12.8375,9.93030535 12.6819566,9.35387983 12.3703883,8.82416548 Z M5.98010698,3.61370253 L8.9132798,3.61370253 C9.57397806,3.62477837 10.0603521,3.78561891 10.3714389,4.09718726 C10.6883044,4.43042574 10.8467372,4.83734267 10.8467372,5.31793805 C10.8467372,5.79853344 10.6883044,6.19726387 10.3714389,6.51412936 C10.0603521,6.85796213 9.57397806,7.03036007 8.9132798,7.03036007 L5.98010698,7.03036007 L5.98010698,3.61370253 Z M10.5602099,11.6836598 C10.2491231,12.0385685 9.75745184,12.2215607 9.08567774,12.2326365 L5.98010698,12.2326365 L5.98010698,8.64454416 L9.08519618,8.64454416 C9.75697029,8.65513845 10.2486415,8.83283353 10.5597283,9.17714786 C10.8708151,9.52675933 11.02684,9.9471599 11.02684,10.4388311 C11.02684,10.9189449 10.8712967,11.3340484 10.5602099,11.6836598 L10.5602099,11.6836598 Z"
      />
    </svg>
  )
}
const FontBoldIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontBoldIcon
